module.exports = __webpack_public_path__ + "static/media/kevinadhiguna.77dd3cf6.png";